import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_1a84675c from 'nuxt_plugin_plugin_1a84675c' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_sentryserver_485e2b94 from 'nuxt_plugin_sentryserver_485e2b94' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_761778ae from 'nuxt_plugin_sentryclient_761778ae' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_plugin_41fceb44 from 'nuxt_plugin_plugin_41fceb44' // Source: ./composition-api/plugin.mjs (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_5fef8fcc from 'nuxt_plugin_cookieuniversalnuxt_5fef8fcc' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_pluginutils_3a8ae409 from 'nuxt_plugin_pluginutils_3a8ae409' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_79629314 from 'nuxt_plugin_pluginrouting_79629314' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_29c150db from 'nuxt_plugin_pluginmain_29c150db' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_toast_5e920921 from 'nuxt_plugin_toast_5e920921' // Source: ./toast.js (mode: 'client')
import nuxt_plugin_gtm_dfaa1070 from 'nuxt_plugin_gtm_dfaa1070' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_axios_db3c871c from 'nuxt_plugin_axios_db3c871c' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_nuxtcloudinaryimageplugin640425d7_f5e72c46 from 'nuxt_plugin_nuxtcloudinaryimageplugin640425d7_f5e72c46' // Source: ./nuxt-cloudinary-image.plugin.640425d7.js (mode: 'all')
import nuxt_plugin_datefns_be925fcc from 'nuxt_plugin_datefns_be925fcc' // Source: ./date-fns.js (mode: 'all')
import nuxt_plugin_axios_3566aa80 from 'nuxt_plugin_axios_3566aa80' // Source: ../plugins/axios (mode: 'all')
import nuxt_plugin_debuglog_63eeb614 from 'nuxt_plugin_debuglog_63eeb614' // Source: ../plugins/debug-log (mode: 'all')
import nuxt_plugin_i18n_6a80ea94 from 'nuxt_plugin_i18n_6a80ea94' // Source: ../plugins/i18n (mode: 'all')
import nuxt_plugin_livepreview_08bb3346 from 'nuxt_plugin_livepreview_08bb3346' // Source: ../plugins/live-preview (mode: 'all')
import nuxt_plugin_adobefonts_64727009 from 'nuxt_plugin_adobefonts_64727009' // Source: ../plugins/adobe-fonts.client (mode: 'client')
import nuxt_plugin_axe_5557c8f0 from 'nuxt_plugin_axe_5557c8f0' // Source: ../plugins/axe (mode: 'client')
import nuxt_plugin_currencyfilter_0bc70a7e from 'nuxt_plugin_currencyfilter_0bc70a7e' // Source: ../plugins/currency-filter (mode: 'all')
import nuxt_plugin_numberfilter_d26d0a74 from 'nuxt_plugin_numberfilter_d26d0a74' // Source: ../plugins/number-filter (mode: 'all')
import nuxt_plugin_fontawesome_47952b5b from 'nuxt_plugin_fontawesome_47952b5b' // Source: ../plugins/font-awesome (mode: 'all')
import nuxt_plugin_instantsearch_341a9313 from 'nuxt_plugin_instantsearch_341a9313' // Source: ../plugins/instantsearch (mode: 'all')
import nuxt_plugin_veevalidate_6e5ad03a from 'nuxt_plugin_veevalidate_6e5ad03a' // Source: ../plugins/vee-validate (mode: 'all')
import nuxt_plugin_vueselect_0c6a19ce from 'nuxt_plugin_vueselect_0c6a19ce' // Source: ../plugins/vue-select (mode: 'all')
import nuxt_plugin_vueawesomeswiper_4af85e3f from 'nuxt_plugin_vueawesomeswiper_4af85e3f' // Source: ../plugins/vue-awesome-swiper (mode: 'client')
import nuxt_plugin_localstorage_63be1e63 from 'nuxt_plugin_localstorage_63be1e63' // Source: ../plugins/local-storage (mode: 'client')
import nuxt_plugin_vueyoutube_c27b0f54 from 'nuxt_plugin_vueyoutube_c27b0f54' // Source: ../plugins/vue-youtube (mode: 'client')
import nuxt_plugin_vuevimeo_2e573437 from 'nuxt_plugin_vuevimeo_2e573437' // Source: ../plugins/vue-vimeo (mode: 'client')
import nuxt_plugin_vtooltip_74057214 from 'nuxt_plugin_vtooltip_74057214' // Source: ../plugins/v-tooltip (mode: 'client')
import nuxt_plugin_vueobservevisibility_c32a0d60 from 'nuxt_plugin_vueobservevisibility_c32a0d60' // Source: ../plugins/vue-observe-visibility (mode: 'client')
import nuxt_plugin_vueclickoutside_7f633153 from 'nuxt_plugin_vueclickoutside_7f633153' // Source: ../plugins/vue-click-outside (mode: 'client')
import nuxt_plugin_focusvisible_4ce9a077 from 'nuxt_plugin_focusvisible_4ce9a077' // Source: ../plugins/focus-visible (mode: 'client')
import nuxt_plugin_auth_39ff967e from 'nuxt_plugin_auth_39ff967e' // Source: ./auth.js (mode: 'all')
import nuxt_plugin_auth_7f7561ce from 'nuxt_plugin_auth_7f7561ce' // Source: ../plugins/auth.js (mode: 'all')
import nuxt_plugin_sentrycontextauth_4fdb09d0 from 'nuxt_plugin_sentrycontextauth_4fdb09d0' // Source: ../plugins/sentry-context.auth.js (mode: 'all')
import nuxt_plugin_meta_0deec756 from 'nuxt_plugin_meta_0deec756' // Source: ./composition-api/meta.mjs (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"hep Verlag","titleTemplate":"%s | hep Verlag","htmlAttrs":{"lang":"de-CH"},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"preconnect","href":"https:\u002F\u002Fuse.typekit.net\u002F","crossorigin":""},{"rel":"dns-prefetch","href":"https:\u002F\u002Fuse.typekit.net\u002F"}],"script":[{"src":"https:\u002F\u002Fcdnjs.cloudflare.com\u002Fpolyfill\u002Fv3\u002Fpolyfill.min.js?features=ResizeObserver%2CMutationObserver"},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-N2M9HVHF')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"bodyAttrs":{"class":""},"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-N2M9HVHF&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_1a84675c === 'function') {
    await nuxt_plugin_plugin_1a84675c(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_sentryserver_485e2b94 === 'function') {
    await nuxt_plugin_sentryserver_485e2b94(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_761778ae === 'function') {
    await nuxt_plugin_sentryclient_761778ae(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_41fceb44 === 'function') {
    await nuxt_plugin_plugin_41fceb44(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_5fef8fcc === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_5fef8fcc(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_3a8ae409 === 'function') {
    await nuxt_plugin_pluginutils_3a8ae409(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_79629314 === 'function') {
    await nuxt_plugin_pluginrouting_79629314(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_29c150db === 'function') {
    await nuxt_plugin_pluginmain_29c150db(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_toast_5e920921 === 'function') {
    await nuxt_plugin_toast_5e920921(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_dfaa1070 === 'function') {
    await nuxt_plugin_gtm_dfaa1070(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_db3c871c === 'function') {
    await nuxt_plugin_axios_db3c871c(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtcloudinaryimageplugin640425d7_f5e72c46 === 'function') {
    await nuxt_plugin_nuxtcloudinaryimageplugin640425d7_f5e72c46(app.context, inject)
  }

  if (typeof nuxt_plugin_datefns_be925fcc === 'function') {
    await nuxt_plugin_datefns_be925fcc(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_3566aa80 === 'function') {
    await nuxt_plugin_axios_3566aa80(app.context, inject)
  }

  if (typeof nuxt_plugin_debuglog_63eeb614 === 'function') {
    await nuxt_plugin_debuglog_63eeb614(app.context, inject)
  }

  if (typeof nuxt_plugin_i18n_6a80ea94 === 'function') {
    await nuxt_plugin_i18n_6a80ea94(app.context, inject)
  }

  if (typeof nuxt_plugin_livepreview_08bb3346 === 'function') {
    await nuxt_plugin_livepreview_08bb3346(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_adobefonts_64727009 === 'function') {
    await nuxt_plugin_adobefonts_64727009(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_axe_5557c8f0 === 'function') {
    await nuxt_plugin_axe_5557c8f0(app.context, inject)
  }

  if (typeof nuxt_plugin_currencyfilter_0bc70a7e === 'function') {
    await nuxt_plugin_currencyfilter_0bc70a7e(app.context, inject)
  }

  if (typeof nuxt_plugin_numberfilter_d26d0a74 === 'function') {
    await nuxt_plugin_numberfilter_d26d0a74(app.context, inject)
  }

  if (typeof nuxt_plugin_fontawesome_47952b5b === 'function') {
    await nuxt_plugin_fontawesome_47952b5b(app.context, inject)
  }

  if (typeof nuxt_plugin_instantsearch_341a9313 === 'function') {
    await nuxt_plugin_instantsearch_341a9313(app.context, inject)
  }

  if (typeof nuxt_plugin_veevalidate_6e5ad03a === 'function') {
    await nuxt_plugin_veevalidate_6e5ad03a(app.context, inject)
  }

  if (typeof nuxt_plugin_vueselect_0c6a19ce === 'function') {
    await nuxt_plugin_vueselect_0c6a19ce(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueawesomeswiper_4af85e3f === 'function') {
    await nuxt_plugin_vueawesomeswiper_4af85e3f(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_localstorage_63be1e63 === 'function') {
    await nuxt_plugin_localstorage_63be1e63(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueyoutube_c27b0f54 === 'function') {
    await nuxt_plugin_vueyoutube_c27b0f54(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuevimeo_2e573437 === 'function') {
    await nuxt_plugin_vuevimeo_2e573437(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vtooltip_74057214 === 'function') {
    await nuxt_plugin_vtooltip_74057214(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueobservevisibility_c32a0d60 === 'function') {
    await nuxt_plugin_vueobservevisibility_c32a0d60(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueclickoutside_7f633153 === 'function') {
    await nuxt_plugin_vueclickoutside_7f633153(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_focusvisible_4ce9a077 === 'function') {
    await nuxt_plugin_focusvisible_4ce9a077(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_39ff967e === 'function') {
    await nuxt_plugin_auth_39ff967e(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_7f7561ce === 'function') {
    await nuxt_plugin_auth_7f7561ce(app.context, inject)
  }

  if (typeof nuxt_plugin_sentrycontextauth_4fdb09d0 === 'function') {
    await nuxt_plugin_sentrycontextauth_4fdb09d0(app.context, inject)
  }

  if (typeof nuxt_plugin_meta_0deec756 === 'function') {
    await nuxt_plugin_meta_0deec756(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
